module.exports = __webpack_public_path__ + "img/editIcon.810b700e.svg";